import { findCollectionPrimitiveFieldByApiName, findCollectionRelationFieldByApiName, useCollectionByName, useDataModelDisplayNames } from '#layers/data-model/public';

export function useCurrentUserVariable() {
	const { collection: usersCollection } = useCollectionByName('MonospaceSystemUser');
	const { getFieldDisplayName } = useDataModelDisplayNames();

	function getCurrentUserFieldPathLabels(path: string): string[] {
		const apiNames = path.split('.');
		let collection = usersCollection.value;
		const labels: string[] = [];

		for (const apiName of apiNames) {
			if (!collection) {
				labels.push(apiName);
				continue;
			}

			const primitiveField = findCollectionPrimitiveFieldByApiName(collection, apiName);

			if (primitiveField) {
				labels.push(getFieldDisplayName(primitiveField));
				collection = undefined;
				continue;
			}

			const relationField = findCollectionRelationFieldByApiName(collection, apiName);

			if (relationField) {
				labels.push(getFieldDisplayName(relationField));
				collection = relationField.oppositeCollection ?? undefined;
				continue;
			}

			labels.push(apiName);
			collection = undefined;
		}

		return labels;
	}

	return { getCurrentUserFieldPathLabels };
}
